import { ControlViewModel } from '../types/control.types';
import { ControlModelPropertyEnum } from '../types/control-model-property';

/**
 * è·åæ§ä»¶å®ä½å±æ§
 *
 */
export function getControlEntityAttributes(
  entityAttributes: any[],
  model: ControlViewModel
): { caption: string; name: string }[] {
  let attributeKeyKeys: string[] = [];
  if (model.entityAttribute) {
    attributeKeyKeys.push(model.entityAttribute);
  }
  // éå'entityAttribute'å¼å¤´å±æ§
  attributeKeyKeys = getControlCustomEntityAttributesKeys(model);
  let attributes = entityAttributes.filter((s) => attributeKeyKeys.includes(s.name));
  attributes = [{ caption: 'è¯·éæ©', name: '' }, ...attributes];
  return attributes;
}

/**
 * è·åæ§ä»¶å®ä½å±æ§
 *
 */
export function getControlCustomEntityAttributesKeys(model: ControlViewModel): string[] {
  const attributes: string[] = [];
  Object.keys(model).map((s) => {
    if (s.startsWith(ControlModelPropertyEnum.EntityAttribute)) {
      attributes.push(model[s]);
    }
  });
  if (model.associatedEntityAttributes) {
    model.associatedEntityAttributes.forEach((s) => {
      if (s) {
        attributes.push(s.target);
      }
    });
  }
  return attributes;
}
